<div>
    <v-row>
        <v-col>
            <v-text-field
                v-model="localBlackList.email"
                label="Email"
                variant="outlined"
                :rules="[(v) => !!v || 'Email is required']"
                validate-on="blur"></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <v-text-field
                v-model="localBlackList.firstName"
                label="First name"
                variant="outlined"
                validate-on="blur"></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <v-text-field
                v-model="localBlackList.lastName"
                label="Last name"
                variant="outlined"
                validate-on="blur"></v-text-field>
        </v-col>
    </v-row>
</div>